/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ShareConfigInsightsScope = typeof ShareConfigInsightsScope[keyof typeof ShareConfigInsightsScope];


export const ShareConfigInsightsScope = {
  full_search: 'full_search',
  selected_profiles: 'selected_profiles',
} as const;
